<template>
  <div class="home-page">

    <FallingPetals />

    <!-- Hero Section -->
    <section id="home" class="hero-section">
      <div class="hero-content">
        <h1>Emily & David</h1>
        <p class="wedding-date">2025年6月15日</p>
        <p class="location">台北大稻埕・河岸會館</p>
      </div>
    </section>

    <!-- Our Story Section -->
    <section id="our-story" class="section our-story-section">
    <div class="container">
      <div class="story-header">
        <h2 class="story-title">不只是一個平凡的愛情故事</h2>
      </div>
      
      <div class="story-text">
        <p class="story-description">
          在2020年，我們在一個充滿鮮花的春日午後相遇。那時候的我們，並不知道這個偶然的邂逅會成為一段美麗旅程的開始。從初識的靦腆問候，到如今攜手步入婚姻的殿堂，我們經歷了無數個共同成長的日子。
        </p>
        <p class="story-description">
          每一次旅行、每一頓晚餐、每一次爭執與和好，都讓我們更加堅信：我們找到了生命中最重要的那個人。如今，我們想邀請您一同見證這段感情的延續，共同慶祝愛情的美好與永恆。
        </p>
      </div>
      
      <!-- 三張照片並排區域 -->
      <div class="photo-gallery">
        <div class="photo-item">
          <img src="https://images.pexels.com/photos/1759823/pexels-photo-1759823.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="在一起的美好時光">
        </div>
        <div class="photo-item">
          <img src="https://images.pexels.com/photos/15130688/pexels-photo-15130688.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="旅行中的風景">
        </div>
        <div class="photo-item">
          <img src="https://images.pexels.com/photos/1131575/pexels-photo-1131575.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="我們的寵物">
        </div>
      </div>
      
      <!-- 名言引用區塊 -->
      <div class="quote-section">
        <blockquote class="love-quote">
          "對世界而言，你是一個人<br>
          但對某個人，你是整個世界"
        </blockquote>
        <cite class="quote-author">Anonymous</cite>
      </div>
    </div>
  </section>

    <!-- Gallery Section -->
    <!-- <section class="gallery-section soft-gradient">
  <div class="container">
    <h2 class="section-title">這是我們的故事</h2>
    <div class="gallery-content">
      <div class="gallery-text">
        <p>
          而現在，我們希望你也能成為這故事的一部分。<br>
          誠摯邀請您來參加我們的婚禮，<br>
          一起見證我們的承諾與幸福。
        </p>
      </div>
    </div>
  </div>
</section> -->

  <section id="gallery" class="section gallery-section">
    <!-- 背景圖片層 -->
    <div class="parallax-background">
      <div class="overlay"></div>
    </div>
    
    <!-- 內容區域 -->
    <div class="container">
      <h2 class="section-title">美好瞬間 即將開始</h2>
      
      <div class="gallery-content">
        <div class="invitation-text">
          <p class="highlight-text">我們誠摯邀請您</p>
          <p>見證我們人生中最重要的一天，與我們一同創造更多珍貴回憶。</p>
          
          <div class="wedding-info">
            <div class="info-item">
              <i class="info-icon date-icon"></i>
              <div class="info-text">
                <h3>婚禮日期</h3>
                <p>2025年5月20日 週六</p>
                <p>下午 3:00</p>
              </div>
            </div>
            
            <div class="info-item">
              <i class="info-icon location-icon"></i>
              <div class="info-text">
                <h3>婚宴地點</h3>
                <p>台北君悅酒店</p>
                <p>台北市信義區松壽路2號</p>
              </div>
            </div>
          </div>
          
          <div class="cta-container">
            <a href="#rsvp" class="rsvp-btn">填寫出席表單</a>
          </div>
        </div>
      </div>
    </div>
  </section>





    <!-- Event Section -->
    <section id="event" class="section event-section">
    <div class="container">
      <div class="wedding-info-container">
        <!-- 左側：時間軸 -->
        <div class="timeline-section">
          <div class="event-timeline">
            <div class="timeline-item">
              <div class="timeline-point"></div>
              <div class="timeline-content">
                <div class="event-time">上午 10:00</div>
                <h3>證婚儀式</h3>
                <p>台北大稻埕・河岸會館</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-point"></div>
              <div class="timeline-content">
                <div class="event-time">中午 12:00</div>
                <h3>午宴</h3>
                <p>台北大稻埕・河岸會館</p>
              </div>
            </div>
            
            <div class="timeline-item">
              <div class="timeline-point"></div>
              <div class="timeline-content">
                <div class="event-time">全天</div>
                <h3>拍照時間</h3>
                <p>會場內外</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 右側：婚禮地點 -->
        <div class="location-section">
          <h3>婚禮地點</h3>
          
          <div class="map-container">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.4679378537367!2d121.50617061500697!3d25.056099283962267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9a0534c7fc5%3A0x5e8e3e9c0d5eed3b!2z5aSn56iz5Z-f5rKz5bK45ZCO6YOo!5e0!3m2!1szh-TW!2stw!4v1651012345678!5m2!1szh-TW!2stw" width="100%" height="280" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          
          <div class="location-details">
            <p class="address">地址：台北市大同區延平北路二段200號</p>
            
            <p class="transport-title">交通：</p>
            <ul class="transport-list">
              <li>捷運：雙連站步行約10分鐘</li>
              <li>公車：大稻埕站下車步行約3分鐘</li>
              <li>停車：會場附近有收費停車場</li>
            </ul>
            
            <div class="reminder">
              <p>提醒：請於儀式開始前15分鐘入場，如有特殊飲食需求，請在RSVP表單中註明</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

    <!-- RSVP Section -->
    <!-- <section id="rsvp" class="section rsvp-section">
      <div class="container">
        <h2 class="section-title">出席回覆</h2>
        <div class="rsvp-form">
          <form @submit.prevent="submitRSVP">
            <div class="form-group">
              <label for="name">姓名</label>
              <input type="text" id="name" v-model="rsvp.name" required>
            </div>
            <div class="form-group">
              <label for="email">電子郵件</label>
              <input type="email" id="email" v-model="rsvp.email" required>
            </div>
            <div class="form-group">
              <label for="phone">電話</label>
              <input type="tel" id="phone" v-model="rsvp.phone" required>
            </div>
            <div class="form-group">
              <label>出席狀態</label>
              <div class="radio-group">
                <label>
                  <input type="radio" v-model="rsvp.attendance" value="yes" required>
                  我會出席
                </label>
                <label>
                  <input type="radio" v-model="rsvp.attendance" value="no">
                  很抱歉，我無法出席
                </label>
              </div>
            </div>
            <div class="form-group" v-if="rsvp.attendance === 'yes'">
              <label for="guests">出席人數</label>
              <select id="guests" v-model="rsvp.guests">
                <option v-for="n in 5" :key="n" :value="n">{{ n }} 人</option>
              </select>
            </div>
            <div class="form-group">
              <label for="message">留言</label>
              <textarea id="message" v-model="rsvp.message" rows="4"></textarea>
            </div>
            <div class="form-group">
              <button type="submit" class="btn-submit">送出</button>
            </div>
          </form>
        </div>
      </div>
    </section> -->
  </div>
  </template>

<script>

import HomeLogic from '@/assets/js/home.js'; // ✅ 匯入你的 home.js，內容需是 export default {...}

export default {
  name: "HomePage",
  mixins: [HomeLogic], // ✅ 正確使用 mixins
};
</script>


<!-- ✅ 匯入你的樣式檔 -->
<style src="@/assets/css/home.css" scoped></style>